export default __webpack_public_path__ + "static/media/ts.ab30cb40.svg";